import React from "react";
import { AnimatedShieldLogo } from "../../graphic/AnimatedShieldLogo";
import styles from "./SiteCenterBox.scss";

/**
 * Narrow centered column with the animated shield, an optional eyebrow, title and subtitle.
 * Use CenterBoxContent / CenterBoxBottom as children for forms.
 * @param graphic – replaces the shield, e.g. a status icon (CheckIcon, WarningIcon)
 * @param actions – buttons shown under the subtitle; one fills the row, several share it evenly.
 *                  Use `children` instead for CenterBoxContent / CenterBoxBottom, which bring their own spacing.
 */
export const SiteCenterBox = ({ graphic, eyebrow, title, subtitle, actions, children }) => {
    return (
        <div className={styles.base}>
            <div className={styles.box}>
                {graphic ? (
                    <div className={styles.graphic}>{graphic}</div>
                ) : (
                    <AnimatedShieldLogo className={styles.shield} />
                )}
                {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
                <h1 className={styles.title}>{title}</h1>
                {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
                {actions ? <div className={styles.actions}>{actions}</div> : null}
                {children}
            </div>
        </div>
    );
};
